import { Settings } from 'luxon';

Settings.defaultZone = 'Asia/Tokyo';
